// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
body {
  --vs-search-input-color: var(--color-main-text);
  --vs-search-input-bg: var(--color-main-background);
  --vs-search-input-placeholder-color: var(--color-text-maxcontrast);
  --vs-font-size: var(--default-font-size);
  --vs-line-height: var(--default-line-height);
  --vs-state-disabled-bg: var(--color-background-hover);
  --vs-state-disabled-color: var(--color-text-maxcontrast);
  --vs-state-disabled-controls-color: var(--color-text-maxcontrast);
  --vs-state-disabled-cursor: not-allowed;
  --vs-disabled-bg: var(--color-background-hover);
  --vs-disabled-color: var(--color-text-maxcontrast);
  --vs-disabled-cursor: not-allowed;
  --vs-border-color: var(--color-border-maxcontrast);
  --vs-border-width: 2px;
  --vs-border-style: solid;
  --vs-border-radius: var(--border-radius-large);
  --vs-controls-color: var(--color-main-text);
  --vs-selected-bg: var(--color-background-hover);
  --vs-selected-color: var(--color-main-text);
  --vs-selected-border-color: var(--vs-border-color);
  --vs-selected-border-style: var(--vs-border-style);
  --vs-selected-border-width: var(--vs-border-width);
  --vs-dropdown-bg: var(--color-main-background);
  --vs-dropdown-color: var(--color-main-text);
  --vs-dropdown-z-index: 9999;
  --vs-dropdown-box-shadow: 0px 2px 2px 0px var(--color-box-shadow);
  --vs-dropdown-option-padding: 8px 20px;
  --vs-dropdown-option--active-bg: var(--color-background-hover);
  --vs-dropdown-option--active-color: var(--color-main-text);
  --vs-dropdown-option--kb-focus-box-shadow: inset 0px 0px 0px 2px var(--vs-border-color);
  --vs-dropdown-option--deselect-bg: var(--color-error);
  --vs-dropdown-option--deselect-color: #fff;
  --vs-transition-duration: 0ms;
  --vs-actions-padding: 0 8px 0 4px;
}
.v-select.select {
  min-height: 44px;
  min-width: 260px;
  margin: 0;
}
.v-select.select .select__label {
  display: block;
  margin-bottom: 2px;
}
.v-select.select .vs__selected {
  height: 32px;
  padding: 0 8px 0 12px;
  border-radius: 18px !important;
  background: var(--color-primary-element-light);
  border: none;
}
.v-select.select .vs__search,
.v-select.select .vs__search:focus {
  margin: 2px 0 0;
}
.v-select.select .vs__dropdown-toggle {
  padding: 0;
}
.v-select.select .vs__clear {
  margin-right: 2px;
}
.v-select.select.vs--open .vs__dropdown-toggle {
  outline: 2px solid var(--color-main-background);
  border-color: var(--color-main-text);
  border-bottom-color: transparent;
}
.v-select.select:not(.vs--disabled, .vs--open) .vs__dropdown-toggle:hover {
  outline: 2px solid var(--color-main-background);
  border-color: var(--color-main-text);
}
.v-select.select.vs--disabled .vs__search,
.v-select.select.vs--disabled .vs__selected {
  color: var(--color-text-maxcontrast);
}
.v-select.select.vs--disabled .vs__clear,
.v-select.select.vs--disabled .vs__deselect {
  display: none;
}
.v-select.select--no-wrap .vs__selected-options {
  flex-wrap: nowrap;
  overflow: auto;
  min-width: unset;
}
.v-select.select--no-wrap .vs__selected-options .vs__selected {
  min-width: unset;
}
.v-select.select--drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 var(--vs-border-radius) var(--vs-border-radius);
  border-top-color: transparent;
  border-bottom-color: var(--color-main-text);
}
.v-select.select .vs__selected-options {
  min-height: 40px;
}
.v-select.select .vs__selected-options .vs__selected ~ .vs__search[readonly] {
  position: absolute;
}
.v-select.select.vs--single.vs--loading .vs__selected,
.v-select.select.vs--single.vs--open .vs__selected {
  max-width: 100%;
  opacity: 1;
  color: var(--color-text-maxcontrast);
}
.v-select.select.vs--single .vs__selected-options {
  flex-wrap: nowrap;
}
.v-select.select.vs--single .vs__selected {
  background: unset !important;
}
.vs__dropdown-menu {
  border-color: var(--color-main-text) !important;
  outline: none !important;
  box-shadow:
    -2px 0 0 var(--color-main-background),
    0 2px 0 var(--color-main-background),
    2px 0 0 var(--color-main-background), !important;
  padding: 4px !important;
}
.vs__dropdown-menu--floating {
  width: max-content;
  position: absolute;
  top: 0;
  left: 0;
}
.vs__dropdown-menu--floating-placement-top {
  border-radius: var(--vs-border-radius) var(--vs-border-radius) 0 0 !important;
  border-top-style: var(--vs-border-style) !important;
  border-bottom-style: none !important;
  box-shadow:
    0 -2px 0 var(--color-main-background),
    -2px 0 0 var(--color-main-background),
    2px 0 0 var(--color-main-background), !important;
}
.vs__dropdown-menu .vs__dropdown-option {
  border-radius: 6px !important;
}
.vs__dropdown-menu .vs__no-options {
  color: var(--color-text-lighter) !important;
}
.user-select .vs__selected {
  padding: 0 2px !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcSelect-GsLmwj9w.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,+CAA+C;EAC/C,kDAAkD;EAClD,kEAAkE;EAClE,wCAAwC;EACxC,4CAA4C;EAC5C,qDAAqD;EACrD,wDAAwD;EACxD,iEAAiE;EACjE,uCAAuC;EACvC,+CAA+C;EAC/C,kDAAkD;EAClD,iCAAiC;EACjC,kDAAkD;EAClD,sBAAsB;EACtB,wBAAwB;EACxB,8CAA8C;EAC9C,2CAA2C;EAC3C,+CAA+C;EAC/C,2CAA2C;EAC3C,kDAAkD;EAClD,kDAAkD;EAClD,kDAAkD;EAClD,8CAA8C;EAC9C,2CAA2C;EAC3C,2BAA2B;EAC3B,iEAAiE;EACjE,sCAAsC;EACtC,8DAA8D;EAC9D,0DAA0D;EAC1D,uFAAuF;EACvF,qDAAqD;EACrD,0CAA0C;EAC1C,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;EAC9B,8CAA8C;EAC9C,YAAY;AACd;AACA;;EAEE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,+CAA+C;EAC/C,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;AACA;;EAEE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kEAAkE;EAClE,6BAA6B;EAC7B,2CAA2C;AAC7C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,+CAA+C;EAC/C,wBAAwB;EACxB;;;oDAGkD;EAClD,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,6EAA6E;EAC7E,mDAAmD;EACnD,oCAAoC;EACpC;;;oDAGkD;AACpD;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,yBAAyB;AAC3B","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\nbody {\n  --vs-search-input-color: var(--color-main-text);\n  --vs-search-input-bg: var(--color-main-background);\n  --vs-search-input-placeholder-color: var(--color-text-maxcontrast);\n  --vs-font-size: var(--default-font-size);\n  --vs-line-height: var(--default-line-height);\n  --vs-state-disabled-bg: var(--color-background-hover);\n  --vs-state-disabled-color: var(--color-text-maxcontrast);\n  --vs-state-disabled-controls-color: var(--color-text-maxcontrast);\n  --vs-state-disabled-cursor: not-allowed;\n  --vs-disabled-bg: var(--color-background-hover);\n  --vs-disabled-color: var(--color-text-maxcontrast);\n  --vs-disabled-cursor: not-allowed;\n  --vs-border-color: var(--color-border-maxcontrast);\n  --vs-border-width: 2px;\n  --vs-border-style: solid;\n  --vs-border-radius: var(--border-radius-large);\n  --vs-controls-color: var(--color-main-text);\n  --vs-selected-bg: var(--color-background-hover);\n  --vs-selected-color: var(--color-main-text);\n  --vs-selected-border-color: var(--vs-border-color);\n  --vs-selected-border-style: var(--vs-border-style);\n  --vs-selected-border-width: var(--vs-border-width);\n  --vs-dropdown-bg: var(--color-main-background);\n  --vs-dropdown-color: var(--color-main-text);\n  --vs-dropdown-z-index: 9999;\n  --vs-dropdown-box-shadow: 0px 2px 2px 0px var(--color-box-shadow);\n  --vs-dropdown-option-padding: 8px 20px;\n  --vs-dropdown-option--active-bg: var(--color-background-hover);\n  --vs-dropdown-option--active-color: var(--color-main-text);\n  --vs-dropdown-option--kb-focus-box-shadow: inset 0px 0px 0px 2px var(--vs-border-color);\n  --vs-dropdown-option--deselect-bg: var(--color-error);\n  --vs-dropdown-option--deselect-color: #fff;\n  --vs-transition-duration: 0ms;\n  --vs-actions-padding: 0 8px 0 4px;\n}\n.v-select.select {\n  min-height: 44px;\n  min-width: 260px;\n  margin: 0;\n}\n.v-select.select .select__label {\n  display: block;\n  margin-bottom: 2px;\n}\n.v-select.select .vs__selected {\n  height: 32px;\n  padding: 0 8px 0 12px;\n  border-radius: 18px !important;\n  background: var(--color-primary-element-light);\n  border: none;\n}\n.v-select.select .vs__search,\n.v-select.select .vs__search:focus {\n  margin: 2px 0 0;\n}\n.v-select.select .vs__dropdown-toggle {\n  padding: 0;\n}\n.v-select.select .vs__clear {\n  margin-right: 2px;\n}\n.v-select.select.vs--open .vs__dropdown-toggle {\n  outline: 2px solid var(--color-main-background);\n  border-color: var(--color-main-text);\n  border-bottom-color: transparent;\n}\n.v-select.select:not(.vs--disabled, .vs--open) .vs__dropdown-toggle:hover {\n  outline: 2px solid var(--color-main-background);\n  border-color: var(--color-main-text);\n}\n.v-select.select.vs--disabled .vs__search,\n.v-select.select.vs--disabled .vs__selected {\n  color: var(--color-text-maxcontrast);\n}\n.v-select.select.vs--disabled .vs__clear,\n.v-select.select.vs--disabled .vs__deselect {\n  display: none;\n}\n.v-select.select--no-wrap .vs__selected-options {\n  flex-wrap: nowrap;\n  overflow: auto;\n  min-width: unset;\n}\n.v-select.select--no-wrap .vs__selected-options .vs__selected {\n  min-width: unset;\n}\n.v-select.select--drop-up.vs--open .vs__dropdown-toggle {\n  border-radius: 0 0 var(--vs-border-radius) var(--vs-border-radius);\n  border-top-color: transparent;\n  border-bottom-color: var(--color-main-text);\n}\n.v-select.select .vs__selected-options {\n  min-height: 40px;\n}\n.v-select.select .vs__selected-options .vs__selected ~ .vs__search[readonly] {\n  position: absolute;\n}\n.v-select.select.vs--single.vs--loading .vs__selected,\n.v-select.select.vs--single.vs--open .vs__selected {\n  max-width: 100%;\n  opacity: 1;\n  color: var(--color-text-maxcontrast);\n}\n.v-select.select.vs--single .vs__selected-options {\n  flex-wrap: nowrap;\n}\n.v-select.select.vs--single .vs__selected {\n  background: unset !important;\n}\n.vs__dropdown-menu {\n  border-color: var(--color-main-text) !important;\n  outline: none !important;\n  box-shadow:\n    -2px 0 0 var(--color-main-background),\n    0 2px 0 var(--color-main-background),\n    2px 0 0 var(--color-main-background), !important;\n  padding: 4px !important;\n}\n.vs__dropdown-menu--floating {\n  width: max-content;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.vs__dropdown-menu--floating-placement-top {\n  border-radius: var(--vs-border-radius) var(--vs-border-radius) 0 0 !important;\n  border-top-style: var(--vs-border-style) !important;\n  border-bottom-style: none !important;\n  box-shadow:\n    0 -2px 0 var(--color-main-background),\n    -2px 0 0 var(--color-main-background),\n    2px 0 0 var(--color-main-background), !important;\n}\n.vs__dropdown-menu .vs__dropdown-option {\n  border-radius: 6px !important;\n}\n.vs__dropdown-menu .vs__no-options {\n  color: var(--color-text-lighter) !important;\n}\n.user-select .vs__selected {\n  padding: 0 2px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
